import { render, staticRenderFns } from "./MatterReportList.vue?vue&type=template&id=3ed2b1e9&"
import script from "./MatterReportList.vue?vue&type=script&lang=js&"
export * from "./MatterReportList.vue?vue&type=script&lang=js&"
import style0 from "./MatterReportList.vue?vue&type=style&index=0&id=3ed2b1e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports